import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { dasBoardReducer } from "./shiftReportsReducer";
import { amazonReportsReducer } from "./amazonReportsReducer";
import { dashboardReducer } from "./dashboardReducer";
import { weightsDataReducer } from "./weightsDataReducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { fleetSettingsReducer } from "./fleetSettingsReducer";
import { scorecardReducer } from "./scorecardReducer";
import { checkReducer } from "./checkReducer";
import { actReducer } from "./actReducer";
import { actIkeaReducer } from "./actIkeaReducer";
import { checkIkeaReducer } from "./checkIkeaReducer";
import { modalReducer } from "./modalReducer";
import { drawerReducer } from "./drawerReducer";
import { customGraphReducer } from "./customGraphReducer";
import { perfomanceReducer } from "./performanceReducer";
import { daAndFleetReducer } from "./daAndFleetReducer";
import { falconReducer } from "./falconReducer";
import { settingsReducer } from "./settingsReducer";
import { scheduleReducer } from "./scheduleReducer";
import { trackerReducer } from "./trackerReducer";
import { payrollReducer } from "./payrollReducer";
import { fleetReportsReducer } from "./fleetReportsReducer";
import { daFeedbackReducer } from "./daFeedbackReducer";
import { daHomeReducer } from "./daHomeReducer";
import { daNotificationsReducer } from "./daNotificationsReducer";
import { primeScheduleReducer } from "./primeScheduleReducer";
import { navMenuReducer } from "./navMenuReducer";

const persistConfigModal = {
  key: "courierModal",
  storage,
};

const persistConfigDrawer = {
  key: "courierDrawer",
  storage,
};

const persistConfigNavMenu = {
  key: "courierNavMenu",
  storage,
};

const persistConfigDasBoard = {
  key: "courierDasBoard",
  storage,
  whitelist: ["currentReport", "currentReportStation", "currentReportDate", "dasBoardRowsPerPage", "recordListFilters"],
};

const persistConfigDashboard = {
  key: "courierDashboard",
  storage,
  whitelist: ["dashboardSettings", "dashboardTableRowsPerPage"],
};

const persistConfigImportPDF = {
  key: "courierImport",
  storage,
  whitelist: ["importPDFTableRowsPerPage", "isAmazonPage"],
};

const persistConfigScorecard = {
  key: "courierScorecard",
  storage,
};

const persistConfigIkeaScorecard = {
  key: "courierIkeaScorecard",
  storage,
};

const persistConfigAct = {
  key: "courierActScorecard",
  storage,
};

const persistConfigActIkea = {
  key: "courierActIkeaScorecard",
  storage,
};

const persistConfigCustomGraph = {
  key: "courierCustomGraph",
  storage,
};

const persistConfigPerfomance = {
  key: "courierPerfomance",
  storage,
};

const persistConfigDaAndFleets = {
  key: "courierDaAndFleets",
  storage,
};

const persistConfigFalcon = {
  key: "courierFalcon",
  storage,
};

const persistConfigSchedule = {
  key: "courierSchedule",
  storage,
};

const persistConfigTracker = {
  key: "courierSchedule",
  storage,
};

const persistConfigSettings = {
  key: "courierSettings",
  storage,
};

const persistConfigPayroll = {
  key: "courierPayroll",
  storage,
};

const persistConfigFleetReports = {
  key: "courierFleetReport",
  storage,
};

const persistConfigDaFeedback = {
  key: "courierDaFeedback",
  storage,
};

const persistConfigHome = {
  key: "courierDaHome",
  storage,
};

const persistConfigNotifications = {
  key: "courierDaNotifications",
  storage,
};

const persistConfigPrimeSchedule = {
  key: "courierPrimeSchedule",
  storage,
};

export const rootReducer = combineReducers({
  auth: authReducer,
  dasBoard: persistReducer(persistConfigDasBoard, dasBoardReducer),
  amazonReports: persistReducer(persistConfigImportPDF, amazonReportsReducer),
  dashboard: persistReducer(persistConfigDashboard, dashboardReducer),
  weightsData: weightsDataReducer,
  fleetSettings: fleetSettingsReducer,
  scoreCardSettings: persistReducer(persistConfigScorecard, scorecardReducer),
  checkTable: persistReducer(persistConfigScorecard, checkReducer),
  checkIkeaTable: persistReducer(persistConfigIkeaScorecard, checkIkeaReducer),
  actTable: persistReducer(persistConfigAct, actReducer),
  actIkeaTable: persistReducer(persistConfigActIkea, actIkeaReducer),
  customGraphsState: persistReducer(persistConfigCustomGraph, customGraphReducer),
  perfomanceScores: persistReducer(persistConfigPerfomance, perfomanceReducer),
  daAndFleets: persistReducer(persistConfigDaAndFleets, daAndFleetReducer),
  falconTable: persistReducer(persistConfigFalcon, falconReducer),
  scheduleTable: persistReducer(persistConfigSchedule, scheduleReducer),
  primeScheduleTable: persistReducer(persistConfigPrimeSchedule, primeScheduleReducer),
  trackerTable: persistReducer(persistConfigTracker, trackerReducer),
  payrollTable: persistReducer(persistConfigPayroll, payrollReducer),
  fleetReports: persistReducer(persistConfigFleetReports, fleetReportsReducer),
  daFeedbackTable: persistReducer(persistConfigDaFeedback, daFeedbackReducer),
  daHomeState: persistReducer(persistConfigHome, daHomeReducer),
  daNotificationsState: persistReducer(persistConfigNotifications, daNotificationsReducer),
  drawerState: persistReducer(persistConfigDrawer, drawerReducer),
  navMenuState: persistReducer(persistConfigNavMenu, navMenuReducer),
  modalState: persistReducer(persistConfigModal, modalReducer),
  settings: persistReducer(persistConfigSettings, settingsReducer),
});

export type RootState = ReturnType<typeof rootReducer>;
